import {
    Alert,
    Avatar,
    Box,
    Collapse,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Popover, Snackbar,
    Tooltip,
    Typography,
    useMediaQuery,
    useTheme
} from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import {useEffect, useState} from "react";
import httpReq from "../../services/httpReq";
import * as lod from "lodash";
import {EditNote, MoreVert, TravelExplore, VideoSettings} from "@mui/icons-material";
import {useLingui} from "@lingui/react";
import {msg} from "@lingui/macro";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import TooltipButton from "../buttons/TooltipButton";
import ProjectVideoItem from "./ProjectVideoItem";
import ModalManageProject from "../modals/asiaEditProject/ModalManageProject";
import {useDispatch, useSelector} from "react-redux";
import {goToCoords} from "../../store/reducers/map";
import {showErrorSnackBar} from "../../store/reducers/errors";
import ModalAddVideo from "../modals/ModalAddVideo";
import {toggleProjectOpen, toggleVideoOpen} from "../../store/reducers/projects";
import {useNavigate} from "react-router-dom";
import modalAddVideo from "../modals/ModalAddVideo";
import modalEditVideo from "../modals/asiaEditProject/ModalEditVideo";

const ProjectListItem = ({project, setReloadProjects}) => {
    const theme = useTheme();
    const {_} = useLingui();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const localStorageProjects = useSelector((state) => state.projects.openLocalStorage);

    const [isLoaded, setIsLoaded] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [video, setVideo] = useState([]);
    const [projectAddModalOpen, setProjectAddModalOpen] = useState(false);
    const [projectEditModalOpen, setProjectEditModalOpen] = useState(false);
    const [videoAddModalOpen, setVideoAddModalOpen] = useState(false);
    const [reloadVideosList, setReloadVideosList] = useState(false);
    const [newVideoID, setNewVideoID] = useState(0);
    const [generatingTracks, setGeneratingTracks] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);


    const open = Boolean(anchorEl);
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const foundProject = (localStorageProjects && localStorageProjects.length > 0) ? localStorageProjects.find(p => p.id === project.id) : null;
    const localProject = {...project, ...foundProject};

    const downLG = useMediaQuery(theme.breakpoints.down('lg'))

    useEffect(() => {
        if (isLoading || isLoaded) return;
        setIsLoading(true);
        httpReq(`/Video/GetListByProject/${localProject.id}`, 'GET', null, true).then(res => {
            if (!res || res.responseAnyError) return;
            const items = [...res.responseData].map((item, k) => {
                const foundVideo = localProject.video ? localProject.video.find(v => v.id === item.id) : null;
                item.color = localProject.color;
                if (!foundVideo) {
                    item = {...item, isOpen: foundProject.isOpen};
                    dispatch(toggleVideoOpen({project: project, video: item}));
                }
                else {
                    item = {...item, isOpen: foundVideo.isOpen};
                }
                return item;
            });
            const p = lod.orderBy(items, ['title'], 'asc')
            setVideo(p);
            setIsLoading(false);
            setReloadVideosList(false)
            setIsLoaded(true);
        });
    }, [isLoaded, isLoading])

    useEffect(() => {
        if(reloadVideosList) {
            setIsLoaded(false)
        }
    },[reloadVideosList])

    useEffect(() => {
        if (generatingTracks && newVideoID !== 0) {
            httpReq('Video/GenerateTracks/' + newVideoID, 'GET', null, true).then((res) => {
                if (!res || res.responseAnyError) return;
                setGeneratingTracks(false)
                setNewVideoID(0);
            })
        }
    }, [generatingTracks, newVideoID])

    const searchOnMap = (project) => {
        if (localProject.coords) {
            const coords = {
                latitude: localProject.coords.coordinates[1],
                longitude: localProject.coords.coordinates[0],
            }
            dispatch(goToCoords(coords));
        } else {
            dispatch(showErrorSnackBar('Coords not found'));
        }
    }

    const editProject = () => {
        navigate('/project/edit/' + localProject.id);
    }

    return (
        <>
            <Box key={`project-list-item-${localProject.id}`} sx={{mb: 1}}>
                <ListItem
                    sx={{
                        borderRadius: localProject.isOpen ? '10px 10px 0 0' : 2,
                        bgcolor: 'action.hover',
                        mb: 0.5,
                        transition: 'all 0.2s',
                    }}
                >
                    <ListItemIcon>
                        <Tooltip
                            title={_(msg`Modifica progetto`)}
                            onClick={() => {
                                setProjectEditModalOpen(true);
                            }}
                        >
                            <Avatar sx={{bgcolor: localProject.color, cursor: 'pointer'}}>
                                <EditNote color="light"/>
                            </Avatar>
                        </Tooltip>
                    </ListItemIcon>
                    <ListItemText
                        primary={_(msg`${localProject.name}`)}
                        primaryTypographyProps={{
                            fontWeight: 600,
                            fontSize: '0.95rem',
                        }}
                    />
                    {downLG ? (
                        <>
                            <IconButton onClick={handleClick}>
                                <MoreVert/>
                            </IconButton>
                            <Popover
                                anchorEl={anchorEl}
                                open={open}
                                // onClose={handleClose}
                                anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
                                PaperProps={{
                                    sx: {
                                        p: 1,
                                        borderRadius: 2,
                                        boxShadow: 4,
                                        minWidth: 200,
                                        bgcolor: 'background.paper',
                                    },
                                }}
                            >
                                <MenuItem
                                    onClick={() => {
                                        setVideoAddModalOpen(true);
                                        handleClose();
                                    }}
                                    sx={{
                                        gap: 1,
                                        borderRadius: 1,
                                        '&:hover': {
                                            bgcolor: 'primary.light',
                                            color: 'primary.contrastText',
                                        },
                                    }}
                                >
                                    <UploadIcon fontSize="small"/>
                                    {_(msg`Upload video`)}
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        editProject();
                                        handleClose();
                                    }}
                                    sx={{
                                        gap: 1,
                                        borderRadius: 1,
                                        '&:hover': {
                                            bgcolor: 'primary.light',
                                            color: 'primary.contrastText',
                                        },
                                    }}
                                >
                                    <VideoSettings fontSize="small"/>
                                    {_(msg`Gestione video`)}
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        dispatch(toggleProjectOpen(project));
                                        setIsLoaded(false);
                                        handleClose();
                                    }}
                                    sx={{
                                        gap: 1,
                                        borderRadius: 1,
                                        '&:hover': {
                                            bgcolor: 'primary.light',
                                            color: 'primary.contrastText',
                                        },
                                    }}
                                >
                                    {localProject.isOpen ? <VisibilityIcon fontSize="small"/> :
                                        <VisibilityOffIcon fontSize="small"/>}
                                    {_(msg`Visualizza progetto`)}
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        searchOnMap(project);
                                        handleClose();
                                    }}
                                    sx={{
                                        gap: 1,
                                        borderRadius: 1,
                                        '&:hover': {
                                            bgcolor: 'primary.light',
                                            color: 'primary.contrastText',
                                        },
                                    }}
                                >
                                    <TravelExplore fontSize="small"/>
                                    {_(msg`Localizza`)}
                                </MenuItem>
                            </Popover>

                        </>
                    ) : (
                        <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                            <TooltipButton
                                title={_(msg`Upload video`)}
                                action={() => setVideoAddModalOpen(true)}
                                icon={<UploadIcon/>}
                            />
                            <TooltipButton
                                title={_(msg`Gestione video`)}
                                action={() => editProject()}
                                icon={<VideoSettings/>}
                            />
                            <TooltipButton
                                title={_(msg`Visualizza progetto`)}
                                action={() => {
                                    dispatch(toggleProjectOpen(project));

                                }}
                                icon={localProject.isOpen ? <VisibilityIcon/> : <VisibilityOffIcon/>}
                            />
                            <TooltipButton
                                title={_(msg`Localizza`)}
                                action={() => searchOnMap(project)}
                                icon={<TravelExplore/>}
                            />
                        </Box>
                    )}
                </ListItem>

                {/* Lista video */}
                {localProject.isOpen &&
                    <Collapse
                        sx={{
                            boxShadow: 'none',
                            borderRight: '1px solid lightgray',
                            borderLeft: '1px solid lightgray',
                            borderBottom: '1px solid lightgray',
                            ml: '0 !important',
                            mt: '0 !important',
                            maxHeight: 300,
                            overflowY: 'auto',
                        }}
                        in={localProject.isOpen}
                        unmountOnExit
                    >
                        <List dense sx={{pl: 2}}>
                            {
                                video.length > 0 ? (
                                    video.map((video, videoIndex) => (
                                        <ProjectVideoItem
                                            setReloadVideosList={setReloadVideosList}
                                            key={`project-video-item-${videoIndex}`}
                                            project={project}
                                            video={video}
                                        />
                                    ))
                                ) : (
                                    <Typography
                                        sx={{
                                            fontSize: '0.85rem',
                                            textAlign: 'center',
                                            mt: 1,
                                            color: 'text.secondary',
                                        }}
                                    >
                                        {_(msg`Nessun video trovato`)}
                                    </Typography>
                                )
                            }
                        </List>
                    </Collapse>
                }


            </Box>
            {(!!projectAddModalOpen || !!projectEditModalOpen) &&
                <ModalManageProject
                    setReloadProjects={setReloadProjects}
                    isOpen={!!projectAddModalOpen || !!projectEditModalOpen}
                    setIsOpen={projectAddModalOpen ? setProjectAddModalOpen : setProjectEditModalOpen}
                    mode={projectAddModalOpen ? 'add' : 'edit'}
                    projectToEdit={project}
                />
            }
            {!!videoAddModalOpen &&
                <ModalAddVideo
                    setReloadVideosList={setReloadVideosList}
                    setGenerateTracks={setGeneratingTracks}
                    videoId={newVideoID}
                    setVideoId={setNewVideoID}
                    isOpen={!!videoAddModalOpen}
                    project={project}
                    setIsOpen={setVideoAddModalOpen}
                />
            }
            {generatingTracks &&
                <Snackbar
                    open={generatingTracks}
                    sx={{mt: 10}}
                    anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                >
                    <Alert severity="info" variant="filled" sx={{width: '100%'}}>
                        {_(msg`Caricamento traccia in corso...`)}
                    </Alert>
                </Snackbar>}

        </>

    )
}

export default ProjectListItem;